import React from 'react';
import {styled} from '@mui/material/styles';
import Button from "@mui/material/Button";
import {CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid";


const StyledProgress = styled(CircularProgress)(({theme}) => ({
    position: 'absolute',
    color: 'white',
}));

const StyledHidden = styled(Grid)(({theme, hidden}) => ({
    opacity: hidden ? 0 : 1,
}));

export default function LoadingButton({ children, onClick, loading, variant, color, progressSize, disabled, ...otherProps }) {

    return (
        <Button
            variant={'contained'}
            color={color}
            onClick={onClick}
            disabled={disabled || loading}
            {...otherProps}
        >
            {loading && <StyledProgress size={progressSize} />}
            <StyledHidden>
                {children}
            </StyledHidden>
        </Button>
    );
}

LoadingButton.defaultProps = {
    variant: 'contained',
    color: 'primary',
    loading: false,
    progressSize: 20,
    disabled: false,
};
